export default __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.84f7e58f.svg";